// ============================================================================
// CHAPITRE 6 : LES MISSIONS DE PAUL - Niveaux 66 à 78 COMPLET
// ============================================================================

export const chapter6PaulMissions = {
  id: 6,
  name: "Les Missions de Paul",
  description: "Jusqu'aux extrémités de la terre...",
  icon: "🌍",
  levelRange: { start: 66, end: 78 },
  
  levels: {
    66: {
      name: "Premier Voyage Missionnaire",
      challenge: "Mettez-moi à part Barnabas et Saul pour l'œuvre à laquelle je les ai appelés...",
      questions: {
        easy: {
          question: "Qui accompagna Paul lors de son premier voyage ?",
          options: ["Pierre", "Barnabas", "Silas", "Timothée"],
          correct: 1,
          hint: "Le 'fils de consolation'",
          funFact: "👥 Barnabas avait accueilli Paul après sa conversion - partenariat providentiel!"
        },
        medium: {
          question: "De quelle ville partirent-ils pour leur mission ?",
          options: [
            "Jérusalem",
            "Antioche de Syrie",
            "Tarse",
            "Damas"
          ],
          correct: 1,
          hint: "La première église mixte juifs-païens",
          funFact: "🚢 Antioche : port de départ de l'évangélisation du monde occidental!"
        },
        hard: {
          question: "Que révèle ce premier voyage sur la stratégie missionnaire ?",
          options: [
            "Il faut rester dans sa région",
            "L'Évangile transcende toutes les frontières culturelles",
            "Seuls les Juifs peuvent être sauvés",
            "La mission est facultative"
          ],
          correct: 1,
          hint: "Il s'agit de l'universalité du message",
          funFact: "🌊 Traverser la Méditerranée = franchir le cap vers l'évangélisation mondiale!"
        }
      }
    },
    
    67: {
      name: "À Chypre avec Élymas",
      challenge: "Homme plein de toute espèce de ruse et de fraude, fils du diable...",
      questions: {
        easy: {
          question: "Quel magicien s'opposa à Paul à Chypre ?",
          options: ["Simon", "Élymas", "Apollos", "Alexandre"],
          correct: 1,
          hint: "Un faux prophète qui voulait détourner le proconsul",
          funFact: "🪄 Premier affrontement direct entre l'Évangile et la magie!"
        },
        medium: {
          question: "Que fit Paul à Élymas pour le punir ?",
          options: [
            "Il le chassa",
            "Il le rendit aveugle temporairement",
            "Il l'ignora",
            "Il débattit avec lui"
          ],
          correct: 1,
          hint: "Une cécité temporaire pour lui ouvrir les yeux spirituels",
          funFact: "👁️ Ironie divine : celui qui aveuglait les âmes devient temporairement aveugle!"
        },
        hard: {
          question: "Comment cet épisode illustre-t-il la puissance de l'Évangile ?",
          options: [
            "La violence est nécessaire",
            "La vérité divine s'impose face au mensonge",
            "Il faut combattre tous les magiciens",
            "Paul était vengeur"
          ],
          correct: 1,
          hint: "Il s'agit de l'autorité divine face à l'imposture",
          funFact: "⚡ Le proconsul croit en voyant la puissance divine - démonstration efficace!"
        }
      }
    },

    68: {
      name: "À Antioche de Pisidie",
      challenge: "C'est à vous d'abord qu'il fallait annoncer la parole de Dieu...",
      questions: {
        easy: {
          question: "Où Paul prêchait-il en arrivant dans une ville ?",
          options: [
            "Sur la place publique",
            "D'abord dans la synagogue",
            "Chez les riches",
            "Dans les temples païens"
          ],
          correct: 1,
          hint: "Il commençait toujours par son peuple",
          funFact: "🕍 Stratégie missionnaire : d'abord aux Juifs, puis aux païens!"
        },
        medium: {
          question: "Comment les Juifs réagirent-ils au message de Paul ?",
          options: [
            "Ils l'acceptèrent tous",
            "Ils furent divisés : certains crurent, d'autres s'opposèrent",
            "Ils restèrent indifférents",
            "Ils l'expulsèrent immédiatement"
          ],
          correct: 1,
          hint: "Division classique face à l'Évangile",
          funFact: "⚖️ L'Évangile divise toujours : acceptation ou rejet, pas d'indifférence!"
        },
        hard: {
          question: "Pourquoi Paul se tourne-t-il vers les païens ?",
          options: [
            "Il préférait les païens",
            "Le rejet des Juifs ouvre la porte aux nations",
            "C'était plus facile",
            "Il abandonnait sa mission"
          ],
          correct: 1,
          hint: "Il s'agit de l'accomplissement prophétique",
          funFact: "🚪 'Lumière des nations' - prophétie d'Ésaïe accomplie par Paul!"
        }
      }
    },

    69: {
      name: "Guérison à Lystre",
      challenge: "Les dieux sous une forme humaine sont descendus vers nous !",
      questions: {
        easy: {
          question: "Qu'est-ce que Paul guérit à Lystre ?",
          options: [
            "Un aveugle",
            "Un paralytique de naissance",
            "Un sourd-muet",
            "Un lépreux"
          ],
          correct: 1,
          hint: "Quelqu'un qui n'avait jamais marché",
          funFact: "🦵 Miracle spectaculaire : 'Lève-toi droit sur tes pieds!' - foi guérisseuse!"
        },
        medium: {
          question: "Pour qui la foule prit-elle Paul et Barnabas ?",
          options: [
            "Des rois",
            "Des dieux (Jupiter et Mercure)",
            "Des magiciens",
            "Des prophètes"
          ],
          correct: 1,
          hint: "Divinités du panthéon grec",
          funFact: "⚡ Barnabas = Jupiter (imposant), Paul = Mercure (orateur) - malentendu culturel!"
        },
        hard: {
          question: "Comment Paul réagit-il à cette adoration idolâtre ?",
          options: [
            "Il accepte les honneurs",
            "Il déchire ses vêtements et prêche le vrai Dieu",
            "Il se tait par politesse",
            "Il profite de la situation"
          ],
          correct: 1,
          hint: "Refus total de l'idolâtrie",
          funFact: "👔 Déchirer ses vêtements = horreur juive devant l'idolâtrie - intégrité totale!"
        }
      }
    },

    70: {
      name: "Lapidation et Résurrection",
      challenge: "Comme les disciples l'entouraient, il se leva et entra dans la ville...",
      questions: {
        easy: {
          question: "Que firent les habitants de Lystre à Paul ?",
          options: [
            "Ils l'emprisonnèrent",
            "Ils le lapidèrent",
            "Ils l'exilèrent",
            "Ils le crucifièrent"
          ],
          correct: 1,
          hint: "Le châtiment juif traditionnel",
          funFact: "🪨 De 'dieu' à 'mort' en un jour - inconstance de la foule humaine!"
        },
        medium: {
          question: "Que fit Paul après avoir été lapidé ?",
          options: [
            "Il fuit la ville",
            "Il se cacha",
            "Il se leva et rentra dans la ville",
            "Il alla à l'hôpital"
          ],
          correct: 2,
          hint: "Courage surnaturel après la mort supposée",
          funFact: "💪 Résurrection miraculeuse ou guérison divine - courage incroyable!"
        },
        hard: {
          question: "Que révèle cette persécution sur le coût du témoignage ?",
          options: [
            "Il faut éviter les conflits",
            "Témoigner pour Christ peut coûter la vie",
            "Paul était imprudent",
            "La persécution est inutile"
          ],
          correct: 1,
          hint: "Il s'agit du prix du témoignage authentique",
          funFact: "✝️ 'Il faut passer par beaucoup de tribulations' - réalisme de Paul!"
        }
      }
    },

    71: {
      name: "Le Concile de Jérusalem",
      challenge: "Si vous n'êtes circoncis, vous ne pouvez être sauvés...",
      questions: {
        easy: {
          question: "Quel débat majeur eut lieu au concile de Jérusalem ?",
          options: [
            "Le baptême",
            "La circoncision des païens convertis",
            "Le jour du sabbat",
            "Les offrandes"
          ],
          correct: 1,
          hint: "Fallait-il devenir juif pour être chrétien ?",
          funFact: "✂️ Première crise majeure : christianisme ou judéo-christianisme ?"
        },
        medium: {
          question: "Quelle fut la décision finale du concile ?",
          options: [
            "Circoncision obligatoire",
            "Liberté pour les païens avec quelques recommandations",
            "Séparation totale d'avec les Juifs",
            "Report de la décision"
          ],
          correct: 1,
          hint: "Ouverture aux païens sans contrainte majeure",
          funFact: "🆓 Révolution historique : l'Évangile libre de la loi mosaïque!"
        },
        hard: {
          question: "Quelle importance ce concile a-t-il pour l'Église universelle ?",
          options: [
            "Événement mineur",
            "Il établit l'universalité du salut par la foi seule",
            "Il divise l'Église",
            "Il renforce le légalisme"
          ],
          correct: 1,
          hint: "Il s'agit du fondement de l'Église universelle",
          funFact: "🌍 Sans cette décision, le christianisme serait resté une secte juive!"
        }
      }
    },

    72: {
      name: "Deuxième Voyage : Timothée",
      challenge: "Paul voulut l'emmener avec lui et le circoncit à cause des Juifs...",
      questions: {
        easy: {
          question: "Qui rejoignit Paul comme jeune collaborateur ?",
          options: ["Marc", "Luc", "Timothée", "Tite"],
          correct: 2,
          hint: "Le 'fils bien-aimé' de Paul",
          funFact: "👦 Timothée : jeune prodige devenu bras droit de Paul - mentorat réussi!"
        },
        medium: {
          question: "Pourquoi Paul circoncit-il Timothée malgré la liberté acquise ?",
          options: [
            "Par obligation légale",
            "Par stratégie missionnaire auprès des Juifs",
            "Par tradition",
            "Par erreur"
          ],
          correct: 1,
          hint: "Sagesse pratique pour éviter les obstacles",
          funFact: "🎯 Liberté avec sagesse : 'Se faire tout à tous pour en gagner quelques-uns'!"
        },
        hard: {
          question: "Comment cette attitude illustre-t-elle la flexibilité missionnaire ?",
          options: [
            "Paul était inconstant",
            "Il adaptait sa méthode sans compromettre l'Évangile",
            "Il cédait à la pression",
            "Il était hypocrite"
          ],
          correct: 1,
          hint: "Il s'agit de sagesse contextuelle",
          funFact: "⚖️ Principes fermes, méthodes flexibles - art du témoignage efficace!"
        }
      }
    },

    73: {
      name: "La Vision de l'Homme Macédonien",
      challenge: "Passe en Macédoine et secours-nous !",
      questions: {
        easy: {
          question: "Que vit Paul dans sa vision nocturne ?",
          options: [
            "Un ange",
            "Un homme de Macédoine l'appelant",
            "Jésus lui parlant",
            "Une grande lumière"
          ],
          correct: 1,
          hint: "Un appel à l'aide venant d'Europe",
          funFact: "🌉 Vision décisive : l'Évangile traverse en Europe - tournant historique!"
        },
        medium: {
          question: "Quelle fut la première ville européenne évangélisée ?",
          options: [
            "Athènes",
            "Corinthe",
            "Philippes",
            "Thessalonique"
          ],
          correct: 2,
          hint: "Colonie romaine en Macédoine",
          funFact: "🏛️ Philippes : première église européenne - continent transformé à jamais!"
        },
        hard: {
          question: "Que symbolise cette vision pour l'histoire du christianisme ?",
          options: [
            "Un rêve ordinaire",
            "L'expansion providentielle vers l'Occident",
            "Une hallucination",
            "Un changement de plan"
          ],
          correct: 1,
          hint: "Il s'agit de la Providence dirigeant l'histoire",
          funFact: "🗺️ Sans cette vision, l'Europe pourrait être restée païenne - plan divin!"
        }
      }
    },

    74: {
      name: "Lydie, Première Convertie Européenne",
      challenge: "Le Seigneur ouvrit le cœur de Lydie pour qu'elle soit attentive...",
      questions: {
        easy: {
          question: "Quel était le métier de Lydie ?",
          options: [
            "Boulangère",
            "Marchande de pourpre",
            "Tisseuse",
            "Potière"
          ],
          correct: 1,
          hint: "Commerce de luxe de l'époque",
          funFact: "🟣 Pourpre = couleur royale très coûteuse - Lydie était prospère!"
        },
        medium: {
          question: "Où Paul rencontra-t-il Lydie ?",
          options: [
            "Au marché",
            "Au bord de la rivière lors d'une prière",
            "Dans sa maison",
            "À la synagogue"
          ],
          correct: 1,
          hint: "Un lieu de prière en plein air",
          funFact: "🏞️ Pas de synagogue à Philippes - prière au bord de l'eau selon la tradition!"
        },
        hard: {
          question: "Que révèle la conversion de Lydie sur l'œuvre divine ?",
          options: [
            "Elle était prédisposée",
            "Dieu ouvre les cœurs préparés à recevoir sa Parole",
            "C'était une coïncidence",
            "Paul était persuasif"
          ],
          correct: 1,
          hint: "Il s'agit de l'action divine dans la conversion",
          funFact: "💝 'Le Seigneur ouvrit son cœur' - Dieu prépare et ouvre les âmes!"
        }
      }
    },

    75: {
      name: "Prison à Philippes",
      challenge: "Vers minuit, Paul et Silas priaient et chantaient les louanges de Dieu...",
      questions: {
        easy: {
          question: "Pourquoi Paul et Silas furent-ils emprisonnés ?",
          options: [
            "Vol",
            "Trouble à l'ordre public en chassant un démon",
            "Blasphème",
            "Émeute"
          ],
          correct: 1,
          hint: "Guérison d'une esclave diseuse de bonne aventure",
          funFact: "💸 Libérer une âme coûte cher à ses exploiteurs - persécution économique!"
        },
        medium: {
          question: "Que firent Paul et Silas en prison ?",
          options: [
            "Ils se plaignirent",
            "Ils priaient et chantaient",
            "Ils préparaient leur défense",
            "Ils dormirent"
          ],
          correct: 1,
          hint: "Louange malgré les chaînes",
          funFact: "🎵 Chants de louange à minuit en prison - foi inébranlable qui impressionne!"
        },
        hard: {
          question: "Comment leur attitude transforma-t-elle la situation ?",
          options: [
            "Elle n'eut aucun effet",
            "Elle convertit le geôlier après le tremblement de terre",
            "Elle agaça les gardiens",
            "Elle les rendit fous"
          ],
          correct: 1,
          hint: "Témoignage puissant par l'exemple",
          funFact: "🌍 Tremblement de terre + témoignage = conversion du geôlier et sa famille!"
        }
      }
    },

    76: {
      name: "À Athènes : L'Aréopage",
      challenge: "Ce que vous révérez sans le connaître, c'est ce que je vous annonce...",
      questions: {
        easy: {
          question: "À quel autel Paul fit-il référence à Athènes ?",
          options: [
            "Au dieu Zeus",
            "Au dieu inconnu",
            "À Apollon",
            "À Athéna"
          ],
          correct: 1,
          hint: "Une inscription mystérieuse qui servit de point de départ",
          funFact: "🏛️ 'Au dieu inconnu' - point de contact génial avec la philosophie grecque!"
        },
        medium: {
          question: "Devant qui Paul prêcha-t-il à Athènes ?",
          options: [
            "La foule ordinaire",
            "Les philosophes épicuriens et stoïciens à l'Aréopage",
            "Les prêtres des temples",
            "L'empereur romain"
          ],
          correct: 1,
          hint: "L'élite intellectuelle grecque",
          funFact: "🧠 Aréopage = Harvard antique - Paul face aux plus grands penseurs!"
        },
        hard: {
          question: "Quelle fut la réaction des Athéniens à la résurrection ?",
          options: [
            "Acceptation unanime",
            "Division : moquerie de certains, intérêt d'autres",
            "Colère générale",
            "Indifférence totale"
          ],
          correct: 1,
          hint: "Réaction typique des intellectuels à ce mystère",
          funFact: "🤔 Résurrection = pierre d'achoppement pour l'intelligence humaine orgueilleuse!"
        }
      }
    },

    77: {
      name: "Corinthe : Tentmaker Paul",
      challenge: "Il demeurait chez eux et travaillait, car ils étaient faiseurs de tentes...",
      questions: {
        easy: {
          question: "Quel métier Paul pratiquait-il pour subvenir à ses besoins ?",
          options: [
            "Pêcheur",
            "Faiseur de tentes",
            "Scribe",
            "Marchand"
          ],
          correct: 1,
          hint: "Métier manuel qu'il avait appris",
          funFact: "⛺ Paul : apôtre-artisan - dignité du travail manuel chez les chrétiens!"
        },
        medium: {
          question: "Chez qui Paul logea-t-il à Corinthe ?",
          options: [
            "Dans une auberge",
            "Chez Aquilas et Priscille",
            "Chez le gouverneur",
            "Dans la synagogue"
          ],
          correct: 1,
          hint: "Un couple de faiseurs de tentes comme lui",
          funFact: "👫 Aquilas et Priscille : couple missionnaire modèle - hospitalité chrétienne!"
        },
        hard: {
          question: "Pourquoi Paul travaillait-il de ses mains ?",
          options: [
            "Par nécessité financière seulement",
            "Pour ne pas être à charge et authentifier son témoignage",
            "Par tradition familiale",
            "Parce qu'il aimait ce métier"
          ],
          correct: 1,
          hint: "Il s'agit d'indépendance et de crédibilité",
          funFact: "💼 Autonomie financière = liberté de parole - Paul ne dépendait de personne!"
        }
      }
    },

    78: {
      name: "Émeute à Éphèse",
      challenge: "Grande est la Diane des Éphésiens !",
      questions: {
        easy: {
          question: "Qui provoqua l'émeute contre Paul à Éphèse ?",
          options: [
            "Les autorités romaines",
            "Démétrius l'orfèvre et les artisans",
            "Les philosophes",
            "Les prêtres juifs"
          ],
          correct: 1,
          hint: "Ceux qui fabriquaient des temples de Diane",
          funFact: "🏛️ Première grève de l'histoire : l'Évangile menace l'économie idolâtre!"
        },
        medium: {
          question: "Combien de temps Paul enseigna-t-il à Éphèse ?",
          options: [
            "6 mois",
            "1 an",
            "2 ans",
            "3 ans"
          ],
          correct: 3,
          hint: "Son plus long séjour missionnaire",
          funFact: "📅 3 ans d'enseignement intensif - Éphèse devint centre missionnaire majeur!"
        },
        hard: {
          question: "Que révèle cette émeute sur l'impact social de l'Évangile ?",
          options: [
            "L'Évangile ne change rien",
            "Il transforme les structures économiques et sociales",
            "Il ne concerne que la religion",
            "Il évite les conflits"
          ],
          correct: 1,
          hint: "Il s'agit de transformation sociétale profonde",
          funFact: "💰 Quand l'Évangile progresse, les idoles perdent leur marché - impact économique!"
        }
      }
    }
  }
};